const Close = (props) => (
  <svg width="10" height="10" viewBox="0 0 10 10" stroke="#769F30" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M8.85162 1.2121L1.21204 8.85168" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M8.85162 8.85168L1.21204 1.2121" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default Close;